var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 9.25625L17.9877 4.125C17.6666 3.88413 17.2766 3.75269 16.8752 3.75H3.1252C2.72378 3.75269 2.33383 3.88413 2.0127 4.125L10.0002 9.25625Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3375 10.5246L10.2313 10.5746H10.1813C10.1237 10.6003 10.0626 10.6172 10 10.6246C9.94812 10.6311 9.89563 10.6311 9.84375 10.6246H9.79375L9.6875 10.5746L1.3125 5.16211C1.27249 5.31307 1.25149 5.46844 1.25 5.62461V14.3746C1.25 14.8719 1.44754 15.3488 1.79917 15.7004C2.15081 16.0521 2.62772 16.2496 3.125 16.2496H16.875C17.3723 16.2496 17.8492 16.0521 18.2008 15.7004C18.5525 15.3488 18.75 14.8719 18.75 14.3746V5.62461C18.7485 5.46844 18.7275 5.31307 18.6875 5.16211L10.3375 10.5246Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.317c290161c02219a6b9c71c5d083b84.svg";
export { ForwardRef as ReactComponent };